export const formatNumber = (number: number | null | undefined, decimals = 2) =>
  typeof number === 'number' ? Number(number.toFixed(decimals)) : number;
